export default [
    {
        path: '',
        name: 'Beranda',
        component: () => import('./page-beranda')
    }
]